// document.addEventListener("DOMContentLoaded", () => {
//   $.ajax({
//     type: "POST",
//     url: "/cart/clear.js",
//     success: function () {
//     },
//     dataType: "json",
//   });
// });

var start_again = document.getElementById("start_again");
start_again.addEventListener("click", start_againf);
function start_againf() {
  document.getElementById("custom_validation_message").classList.add("hide");
  document.body.classList.remove("popup_open");
  document.getElementById("p1").classList.remove("hide");
  document.getElementById("p2").classList.remove("hide");
  document.getElementById("p3").classList.remove("hide");
}

var button = document.getElementById("statement_yes");
button.addEventListener("click", statementcase);

function statementcase() {
  document.getElementById("custom_validation_message").classList.remove("hide");
  document.body.classList.add("popup_open");
}

statement_no.addEventListener("click", statement_nof);

function statement_nof() {
  document.getElementById("custom_validation_message").classList.add("hide");
  document.getElementById("step2").classList.remove("hide");
  document.getElementById("step3").classList.remove("hide");
  document.getElementById("step4").classList.remove("hide");

  var elem = document.getElementById("step2");
  elem.scrollIntoView({ behavior: "smooth" });
  return false;
}

var btn_click = document.getElementsByClassName("btn_click");
for (var i = 0; i < btn_click.length; i++) {
  (function (index) {
    btn_click[index].addEventListener("click", function () {
      for (var j = 0; j < btn_click[index].parentElement.children.length; j++) {
        btn_click[index].parentElement.children[j].classList.remove("active");
      }
      // alert(btn_click[index].getAttribute('data-step'));
      var input_value = btn_click[index].getAttribute("data-id");
      if (input_value) {
        document
          .getElementById(input_value)
          .setAttribute("value", btn_click[index].getAttribute("data-value"));
      }

      var scrollc = document.getElementById(
        btn_click[index].getAttribute("data-step")
      );
      scrollc.scrollIntoView({ behavior: "smooth" });

      btn_click[index].classList.add("active");

      // Hide validation message
      btn_click[index].parentElement.parentElement
        .querySelectorAll(".validation")[0]
        .classList.add("hide");

      // Hide products block
      document.getElementById("products").classList.add("hide");
      document.getElementById("pro-dual").classList.add("hide");
      document.getElementById("pro-upper").classList.add("hide");
      document.getElementById("pro-lower").classList.add("hide");
      document.getElementById("standard-dual").classList.add("hide");
      document.getElementById("standard-upper").classList.add("hide");
      document.getElementById("standard-lower").classList.add("hide");
      document.getElementById("product-pro-footer-txt").classList.add("hide");
      document
        .getElementById("product-standard-footer-txt")
        .classList.add("hide");

      // Hide product inner blocks
      document.getElementById("pro-dual-suitable").classList.add("hide");
      document.getElementById("pro-dual-email").classList.add("hide");
      document.getElementById("pro-dual-unsuitable").classList.add("hide");
      document.getElementById("pro-upper-suitable").classList.add("hide");
      document.getElementById("pro-upper-email").classList.add("hide");
      document.getElementById("pro-upper-unsuitable").classList.add("hide");
      document.getElementById("pro-lower-suitable").classList.add("hide");
      document.getElementById("pro-lower-email").classList.add("hide");
      document.getElementById("pro-lower-unsuitable").classList.add("hide");
      document.getElementById("standard-dual-suitable").classList.add("hide");
      document.getElementById("standard-dual-email").classList.add("hide");
      document.getElementById("standard-dual-unsuitable").classList.add("hide");
      document.getElementById("standard-upper-suitable").classList.add("hide");
      document.getElementById("standard-upper-email").classList.add("hide");
      document
        .getElementById("standard-upper-unsuitable")
        .classList.add("hide");
      document.getElementById("standard-lower-suitable").classList.add("hide");
      document.getElementById("standard-lower-email").classList.add("hide");
      document
        .getElementById("standard-lower-unsuitable")
        .classList.add("hide");

      // Hide unsuitable/contact us blocks
      // Unhide product container by default
      document.getElementById("product-unsuitable").classList.add("hide");
      document.getElementById("product-contact-us").classList.add("hide");
      document.getElementById("product-container-div").classList.remove("hide");

      // Check if product selected (pro/standard)
      //  and submit hidden form to validate and display products
      if (input_value === "product-selected") {
        document.getElementById("quiz-submit").click();
      }

      // Check if step 2/3 were clicked
      //  to clear step 4 to ensure product selected step is always last to be clicked
      if (
        input_value === "top-teeth-straighten" ||
        input_value === "bottom-teeth-straighten"
      ) {
        document.getElementById("product_pro").classList.remove("active");
        document.getElementById("product_standard").classList.remove("active");
      }
    });
  })(i);
}

function statementcase(evt) {
  document.getElementById("custom_validation_message").classList.remove("hide");
  document.getElementById("step2").classList.add("hide");
  document.getElementById("step3").classList.add("hide");
  document.getElementById("step4").classList.add("hide");
  document.body.scrollIntoView({ behavior: "smooth" });
  if (evt.currentTarget.myParam == "top") {
    document.getElementById("p3").classList.add("hide");
    document.getElementById("p2").classList.add("hide");
  }

  if (evt.currentTarget.myParam == "body") {
    document.getElementById("p1").classList.add("hide");
    document.getElementById("p2").classList.add("hide");
  }

  evt.currentTarget.classList.remove("active");
}

var learn_more_click = document.getElementsByClassName("lm_popup");
for (var i = 0; i < learn_more_click.length; i++) {
  (function (index) {
    learn_more_click[index].addEventListener("click", function () {
      // alert(btn_click[index].getAttribute('data-step'));
      var leanmore = document.getElementById(
        learn_more_click[index].getAttribute("data-popup")
      );

      leanmore.classList.remove("hide");
      document.body.classList.add("popup_open");
    });
  })(i);
}

var close_pp_click = document.getElementsByClassName("close_pp");
for (var i = 0; i < close_pp_click.length; i++) {
  (function (index) {
    close_pp_click[index].addEventListener("click", function () {
      // alert(btn_click[index].getAttribute('data-step'));
      var leanmore = document.getElementById(
        close_pp_click[index].getAttribute("data-close")
      );

      leanmore.classList.add("hide");
      document.body.classList.remove("popup_open");
      document.getElementById("p1").classList.remove("hide");
      document.getElementById("p2").classList.remove("hide");
      document.getElementById("p3").classList.remove("hide");
    });
  })(i);
}

var params = new URL(document.location).searchParams;
var contact_posted = params.get("contact_posted");
if (contact_posted == "true") {
  document.getElementById("custom_validation_message").classList.add("hide");
  document.getElementById("step2").classList.remove("hide");
  document.getElementById("step3").classList.remove("hide");
  document.getElementById("step4").classList.remove("hide");

  var scrollc1 = document.getElementById("step4");
  scrollc1.scrollIntoView({ behavior: "smooth" });
}

document.getElementById("quiz-form").addEventListener("submit", function (e) {
  e.preventDefault(); //Prevent submit event from refreshing the page
  var isFormValid = true;

  for (var i = 0; i < e.srcElement.length; i++) {
    if (e.srcElement[i].type === "text" && e.srcElement[i].value === "") {
      var step = document.getElementById(
        e.srcElement[i].getAttribute("data-step")
      );
      step.querySelectorAll(".validation")[0].classList.remove("hide");

      if (isFormValid) {
        step.scrollIntoView({ behavior: "smooth" });
        isFormValid = false;
      }
    }
  }

  if (isFormValid) {
    // Get products based on quiz answers
    var topStraighten = document.getElementById("top-teeth-straighten").value;
    var bottomStraighten = document.getElementById("bottom-teeth-straighten").value;
    var productSelected = document
      .getElementById("product-selected")
      .value.toLowerCase();

    // Default is to show dual suitable block (product price & ATC button)
    var isDualSuitable = true;

    var isTopStraighten = topStraighten === 'YES';
    var isBottomStraighten = bottomStraighten === 'YES';

    // If upper AND lower NO then hide all products
    //  Show content block to redirect to instasmile veneers
    if (!isTopStraighten && !isBottomStraighten) {
      setHide("product-container-div", true);
      setHide("product-unsuitable", false);
    } 
    else if (isTopStraighten && isBottomStraighten)
    {
      setSuitableBackground(productSelected + "-dual", true);
      setHide(productSelected + "-dual-suitable", false);

      // Hide/Show correct btn
      setHide(productSelected + "-dual-contact-btn", true);
      setHide(productSelected + "-dual-atc-btn", false);

      // Show "Most Popular" as dual suitable
      setHide("most-popular", false);
      document.getElementById("pro-dual").classList.add("isPopular");
    }

    // Show the products container
    setHide("products", false);

    if (isTopStraighten && isBottomStraighten) {
      // Show the dual product block
      setHide(productSelected + "-dual", false);
    } 
    else if (isTopStraighten)
    {
      // Show the upper product block
      setHide(productSelected + "-upper", false);
      setHide(productSelected + "-upper-contact-btn", true);
      setHide(productSelected + "-upper-suitable", false);
    }
    else if (isBottomStraighten)
    {
      // Show the lower product block
      setHide(productSelected + "-lower", false);
      setHide(productSelected + "-lower-contact-btn", true);
      setHide(productSelected + "-lower-suitable", false);
    }

    // Show the product footer text
    if(productSelected !== "pro")
    {
      setHide("product-" + productSelected + "-footer-txt", false);
    }
  }

  function processCrowding(crowding, position) {
    if (crowding === "SEVERE") {
      setGreyBackground(productSelected + "-" + position, true);
      setHide(productSelected + "-" + position + "-unsuitable", false);

      // Hide/Show correct btn
      setHide(productSelected + "-" + position + "-contact-btn", true);
      setHide(productSelected + "-" + position + "-atc-btn", true);

      isDualSuitable = false;
    } else if (crowding === "MILD" || crowding === "NONE") {
      setSuitableBackground(productSelected + "-" + position, true);
      setHide(productSelected + "-" + position + "-suitable", false);

      // Hide/Show correct btn
      setHide(productSelected + "-" + position + "-contact-btn", true);
      setHide(productSelected + "-" + position + "-atc-btn", false);
    } else {
      setAmberBackground(productSelected + "-" + position, true);
      setHide(productSelected + "-" + position + "-email", false);

      // Hide/Show correct btn
      setHide(productSelected + "-" + position + "-contact-btn", false);
      setHide(productSelected + "-" + position + "-atc-btn", true);

      if (position === "upper") {
        isUpperModerate = true;
      } else {
        isLowerModerate = true;
      }
    }
  }

  function setHide(divId, hide) {
    document.getElementById(divId).classList.toggle("hide", hide);
  }

  function setGreyBackground(divId, shouldSetGrey) {
    document
      .getElementById(divId)
      .classList.toggle("grey-background", shouldSetGrey);
  }

  function setSuitableBackground(divId, shouldSetBackground) {
    // Default blue background (standard)
    var backgroundColour = '#DCEFF5';
    
    if (divId.includes('pro')){
      backgroundColour = '#DFF7F3';
    }
    
    shouldSetBackground ? document.getElementById(divId).style.background = backgroundColour : false;
  }

  function setGreenBackground(divId, shouldSetGreen) {
    shouldSetGreen ? document.getElementById(divId).style.background = "#DFF7F3" : false;
  }

  function setAmberBackground(divId, shouldSetAmber) {
    shouldSetAmber ? document.getElementById(divId).style.background = "#FFF2E6" : false;
  }

  function setRedBackground(divId, shouldSetRed) {
     shouldSetRed ? document.getElementById(divId).style.background = "#FFE6E6" : false;
  }
});

function changeProductAnswer(newProductSelected) {
  var currentProductSelected = document
      .getElementById("product-selected")
      .value.toLowerCase();

  if (currentProductSelected === 'pro') {
    document.getElementById('product_standard').click();
  } 
  else if (currentProductSelected === 'standard'){
    document.getElementById('product_pro').click();
  }

  document.getElementById("quiz-submit").click();
}

function addToCart(productSelected) {
  Shopify.queue = [];

  const productIds = {
    proDual: "47929201525046",
    proUpper: "47929193955638",
    proLower: "47929196183862",
    standardDual: "47929174458678",
    standardUpper: "47929164529974",
    standardLower: "47929169314102",
  };

  // Impression kit
  Shopify.queue.push({
    variantId: 47929214271798,
    quantity: 1
  });

  // Product
  Shopify.queue.push({
    variantId: productIds[productSelected],
    quantity: 1
  });

  $.ajax({
    type: "POST",
    url: '/cart/clear.js',
    success: function(){
      Shopify.moveAlong();
    },
    dataType: 'json'
  });
}

Shopify.addItem = function (id, qty, properties, callback) {
  var params = {
    quantity: qty,
    id: id,
    properties: properties,
  };

  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    dataType: "json",
    data: params,
    success: function () {
      if (typeof callback === "function") {
        callback();
      }
    },
    error: function () {},
  });
};

Shopify.moveAlong = function() {
  // If we still have requests in the queue, let's process the next one.
  if (Shopify.queue.length) {
    var request = Shopify.queue.shift();
    Shopify.addItem(request.variantId, request.quantity,  request.properties, Shopify.moveAlong);
  }
  // If the queue is empty, we will redirect to the cart page.
  else {
    document.location.href = '/cart';
  }
};